export default __webpack_public_path__ + "static/media/DreamJobs1_19.0fcd322d.png";